import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.default,
    padding: spacing.medium,

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: spacing.large,
    },
  }),
}

export default styles
